import type { FC, PropsWithChildren } from "react";

interface MultiProviderProps {
	providers: FC<PropsWithChildren>[];
}

export const MultiContextProvider: FC<PropsWithChildren<MultiProviderProps>> = ({ providers, children }) => (
	<>
		{/* Reverse so they render in the order you specify them*/}
		{providers
			.slice()
			.reverse()
			.reduce(
				(acc, Provider) => (
					<Provider>{acc}</Provider>
				),
				children,
			)}
	</>
);
